import React from 'react';
import { IconProps } from './types';

export const SortDownIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill={color} d='M20.6 7.7L12 16.3 3.4 7.7' />
    </svg>
  );
};
